<template>
<v-main>
  <v-layout row>
    <v-flex xs12 sm6 class="pa-3 pl-4 pb-4">
      <v-card dark @click="" :to="{path:'listaUnidade'}" hover color="cyan darken-2" class="rounded-xl">
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title class="headline mb-1">
              Unidades
            </v-list-item-title>
            <!-- <v-list-item-subtitle>Greyhound divisely hello coldly fonwderfully</v-list-item-subtitle> -->
          </v-list-item-content>

          <v-list-item-avatar tile size="80">
            <v-img weight="80px" :src="require('../../assets/iconsAdmUnidade/unidade.png')"></v-img>

          </v-list-item-avatar>
        </v-list-item>
        <!-- <v-layout justify-center>
        <v-flex xs12>
          <v-card-title primary-title>
            <div>
              <div class="headline">Unidades</div>
            </div>
          </v-card-title>
        </v-flex>
        <v-flex xs4>
          <v-img weight="60px" :src="require('../../assets/iconsAdmUnidade/unidade.png')"></v-img>
        </v-flex>
      </v-layout> -->
        <v-divider light></v-divider>
        <v-card-actions class="pa-3">
          {{qtdUnidade}} Unidades cadastradas
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-flex>

    <v-flex xs12 sm6 class="pa-3 pb-4">
      <v-card dark @click="" :to="{path:'listaAdministrador'}" hover color="cyan darken-2" class="rounded-xl mr-2">
        
       
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title class="headline mb-1">
              Administradores
            </v-list-item-title>
            <!-- <v-list-item-subtitle>Greyhound divisely hello coldly fonwderfully</v-list-item-subtitle> -->
          </v-list-item-content>

          <v-list-item-avatar tile size="80">
                       <v-img weight="60px" :src="require('../../assets/iconsAdmUnidade/administrador.png')"></v-img>

          </v-list-item-avatar>
        </v-list-item>
        <v-divider light></v-divider>
        <v-card-actions class="pa-3">
          {{qtdAdministrador}} Administradores de unidades cadastrados
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-flex>
  </v-layout>
</v-main>
</template>

<script>
import Cookies from 'js-cookie'
import administradorService from '../../services/administrador.service'

export default {
  name: 'cadastrarLocalUnidade',
  data() {
    return {
      isEditing: true,
      descricaoLocal: null,
      qtdUnidade: '',
      qtdAdministrador: ''
    }
  },
  components: {
    // HelloWorld
  },
  methods: {
    retornarDashboard() {
      console.log(' em retornar dados dash ..')

      administradorService.administrador
        .retornarDashboard()
        .then(rsp => {
          console.log('rsp oi:')
          console.log(rsp.data)
          this.qtdAdministrador = rsp.data[0].administradorUnidade
          this.qtdUnidade = rsp.data[0].unidade
        })
        .catch(err => {
          // handle your error here
          console.log(err)
        })
    }
  },

  mounted() {
    console.log('em mounted dash empresa...')
    // console.log(this.user);
    this.user = this.$store.getters.usuario
    if (this.user.tipo != 1) {
      this.$router.push('/login')
      return
    }
    console.log(this.$store.getters.usuario)
    this.retornarDashboard()
  },
  created() {
    console.log('created...')
  }
}
</script>

<style scoped>
.md-card {
  width: 320px;
  margin: 4px;
  display: inline-block;
  vertical-align: top;
}

.feedback {
  background-color: #31B0D5;
  color: white;
  padding: 10px 20px;
  border-radius: 4px;
  border-color: #46b8da;
}

#mybutton {
  position: fixed;
  bottom: -4px;
  right: 10px;
}
</style>
